import { useGraphqlDataSource } from 'modules/core/hooks/useGraphqlDataSource'
import { FinanceBudgetDetailDataCollectionTrainingProvidersFilterDocument } from 'generated/resources/graphql'
import { InFilterDefinition } from '@factorialco/f0-react'

export const useTrainingProviderFilter = (label: string): InFilterDefinition<string> => {
  const source = useGraphqlDataSource({
    document: FinanceBudgetDetailDataCollectionTrainingProvidersFilterDocument,
    paginationType: 'infinite-scroll',
    fetchPolicy: 'cache-first',
    perPage: 25,
    mapData: (data) =>
      data.trainings.providers.edges
        .map((edge) => edge.node)
        .filter((node) => node.externalProvider),
    mapPagination: (data) => ({
      total: data.trainings.providers.totalCount ?? 0,
      cursor: data.trainings.providers.pageInfo.endCursor ?? '0',
      hasNextPage: data.trainings.providers.pageInfo.hasNextPage ?? false,
    }),
    mapVariables: ({ search }) => ({
      filter: {
        external: { eq: true },
        externalProvider: search?.trim() ? { contains: search } : { notEq: '' },
      },
    }),
  })

  return {
    label: label,
    type: 'in' as const,
    options: {
      source,
      mapOptions: (node: { externalProvider: string }) => ({
        label: node.externalProvider,
        value: node.externalProvider,
      }),
    },
  }
}
